var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.63541 7.51041H0.375C0.167906 7.51041 0 7.3425 0 7.13541V0.875C0 0.667906 0.167906 0.5 0.375 0.5H1.875C2.08209 0.5 2.25 0.667906 2.25 0.875V3.316C3.68041 1.72747 5.75812 0.733437 8.06797 0.750219C12.3463 0.781281 15.7695 4.23844 15.7604 8.51684C15.7513 12.7893 12.285 16.25 8.01041 16.25C6.00763 16.25 4.18241 15.4902 2.80697 14.2433C2.64762 14.0988 2.64028 13.851 2.79238 13.6989L3.85384 12.6374C3.99366 12.4976 4.21828 12.49 4.36637 12.621C5.33625 13.4792 6.61188 14 8.01041 14C11.05 14 13.5104 11.5401 13.5104 8.5C13.5104 5.46041 11.0505 3 8.01041 3C6.18241 3 4.56416 3.88987 3.56434 5.26041H6.63541C6.8425 5.26041 7.01041 5.42831 7.01041 5.63541V7.13541C7.01041 7.3425 6.8425 7.51041 6.63541 7.51041Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.7a04473be750220a7b9926b4d9274cce.svg";
export { ForwardRef as ReactComponent };